export const heroVideo =
  'https://cdn.magicpatterns.com/uploads/9fNQQDYvLc9Xb3n4zaGRuW/14%20William%20Street%20South%20Yarra.mp4'

export const keyStats = [
  { value: '5', label: 'Bedrooms' },
  { value: '3', label: 'Bathrooms' },
  { value: '2', label: 'Car Spaces' },
  { value: '900', label: 'SQM Approx.' },
]

export const propertyDetails = [
  {
    label: 'Ground Floor',
    text: "Formal living and dining rooms lead to a European kitchen with butler's pantry, a family room and a private rear garden. A study opens onto the garden.",
  },
  {
    label: 'First Floor',
    text: 'Five bedrooms. The main bedroom opens onto a balcony that wraps the first floor.',
  },
  {
    label: 'Services',
    text: 'Hydronic heating and a new slate roof.',
  },
]

export const settingNotes = [
  'Metres from Toorak Road. Walk to Chapel Street, trams and the station.',
  'Close to Christ Church Grammar, Melbourne Grammar, Melbourne Girls Grammar and Melbourne High.',
  'New parkland directly opposite.',
]
